import { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import BlackTriangleDown from '../images/black-triangle-icon-down.svg';

const StyledDetails = styled.details`
  summary {
    display: flex;
    align-items: center;
    list-style: none;
    cursor: pointer;

    /* list-style:none does not remove native toggle button in safari */
    &::-webkit-details-marker {
      display: none;
    }

    &::after {
      content: '';
      background: url(${BlackTriangleDown}) no-repeat transparent;
      width: 10px;
      height: 6px;
      margin-left: .5em;
      transform-origin: center;
    }
  }

  &[open] {
    summary::after {
      transform: rotate(180deg);
    }
  }
`;

const Content = styled.div`
  padding-top: 10px;
`;

interface BasicAccordionProps {
  summary: string | ReactNode;
  open: boolean;
  setOpen: (state: boolean) => void;
}

const BasicAccordion = ({
  children,
  summary,
  open,
  setOpen,
}: PropsWithChildren<BasicAccordionProps>) => (
  <StyledDetails
    open={open}
    onToggle={(event) => setOpen(event.currentTarget.open)}
  >
    <summary>
      {summary}
    </summary>
    <Content>
      {children}
    </Content>
  </StyledDetails>
);

export default BasicAccordion;
